import { SignUpRequest } from "../../model/auth";
import { authSlice } from "../reducer/auth";

const sagaActions = {
  GENERATE_OTP_SAGA: 'GENERATE_OTP_SAGA',
  VERIFY_OTP_SAGA: 'VERIFY_OTP_SAGA',
  FORGOT_PASSWORD_SAGA: 'FORGOT_PASSWORD_SAGA',
  RESET_PASSWORD_SAGA: 'RESET_PASSWORD_SAGA',
  LOGOUT_SAGA: 'LOGOUT_SAGA',
};

export const actionTypes = {
  SIGNIN: "SIGNIN",
  SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
  SIGNIN_ERROR: "SIGNIN_ERROR",
  SIGNUP: "SIGNUP",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_ERROR: "SIGNUP_ERROR",
  LOGOUT: "LOGOUT",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_ERROR: "LOGOUT_ERROR",
  GENERATE_OTP: "GENERATE_OTP",
  GENERATE_OTP_SUCCESS: "GENERATE_OTP_SUCCESS",
  GENERATE_OTP_ERROR: "GENERATE_OTP_ERROR",
  VERIFY_OTP: "VERIFY_OTP",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
  VERIFY_OTP_ERROR: "VERIFY_OTP_ERROR",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_ERROR: "FORGOT_PASSWORD_ERROR",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_ERROR: "RESET_PASSWORD_ERROR",
  RESET_ERROR: "RESET_ERROR",
  ...sagaActions
};

export const generateOtp = (payload: any) => {
  return { type: actionTypes.GENERATE_OTP_SAGA, payload };
};

export const generateOtpSuccess = () => {
  return { type: actionTypes.GENERATE_OTP_SUCCESS };
};

export const generateOtpError = (payload: any) => {
  return { type: actionTypes.GENERATE_OTP_ERROR, payload };
};

export const verifyOtp = (payload: any) => {
  return { type: actionTypes.VERIFY_OTP_SAGA, payload };
};

export const verifyOtpSuccess = () => {
  return { type: actionTypes.VERIFY_OTP_SUCCESS };
};

export const verifyOtpError = (payload: any) => {
  return { type: actionTypes.VERIFY_OTP_ERROR, payload };
};

export const forgotPassword = (payload: any) => {
  return { type: actionTypes.FORGOT_PASSWORD_SAGA, payload };
};

export const logout = () => {
  return { type: actionTypes.LOGOUT_SAGA };
};

export const logoutSuccess = () => authSlice.actions.logoutSuccess();

export const logoutError = (payload: any) => authSlice.actions.logoutError(payload);

export const resetPassword = (payload: any) => {
  return { type: actionTypes.RESET_PASSWORD_SAGA, payload };
};

export const resetPasswordSuccess = () => {
  return { type: actionTypes.RESET_PASSWORD_SUCCESS };
};

export const resetPasswordError = (payload: any) => {
  return { type: actionTypes.RESET_PASSWORD_ERROR, payload };
};
